module.exports = __webpack_public_path__ + "static/media/lamp-desk.2ae28bdb.svg";